import {PageFragment, PageFragmentProps, PageFragmentState} from "../shared/PageFragment";
import {Members} from "../shared/entities";
import {UserMetadata, UserProfile} from "./types";
import React, {ReactElement} from "react";
import {NotFoundFragment} from "../shared/NotFoundFragment";
import {BrokenImageOutlined} from "@mui/icons-material";
import {Action} from "../shared/types";

export type BaseShowcaseFragmentProps = PageFragmentProps & {}

export type BaseShowcaseFragmentState = PageFragmentState & {
  userProfile: UserProfile,
}

export abstract class BaseShowcaseFragment<P extends BaseShowcaseFragmentProps = BaseShowcaseFragmentProps, S extends BaseShowcaseFragmentState = BaseShowcaseFragmentState> extends PageFragment<P, S> {

  protected getIntrinsicHeight(): number | string {
    return null;
  }

  componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot?: any) {
    super.componentDidUpdate(prevProps, prevState, snapshot);
    if (prevProps.path.params.username !== this.props.path.params.username) {
      this.reload(true);
    }
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    const usernameParam = this.props.path.params.username;
    const username = usernameParam.startsWith("@") ? usernameParam.substring(1) : usernameParam;
    const member = await Members.getInstance().getOrLoadMemberByUsername(username);
    if (member) {
      const userProfile: UserProfile = {
        member: member,
        metadata: await UserMetadata.load(member.memberId),
      };
      this.setState({
        userProfile: userProfile,
      });
      return userProfile;
    }
    return null;
  }

  renderContent(): React.ReactElement | null {
    if (!this.state.userProfile) {
      return <NotFoundFragment path={this.props.path} config={{
        iconType: BrokenImageOutlined,
        title: "Not found",
        text: "This content is currently unavailable.",
        action: new Action("Go Home", () => this.props.path.navigate("/")),
      }}/>;
    }
    return this.renderPageContent();
  }

  protected abstract renderPageContent(): ReactElement | null;
}